import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App';
import { ExtensionPage } from './pages/ExtensionPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { SharedPage } from './pages/SharedPage';
import { queryClient } from './lib/query-client';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/extension" element={<ExtensionPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/s/:shareId" element={<SharedPage />} />
          <Route path="/s/:shareId/:slug" element={<SharedPage />} />
        </Routes>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>
);
